export default class AnnouncementInfo {
  constructor(
    public title: string,
    public category: string,
    public date: string,
    public body: any
  ) {}
}
